import { useDispatch } from 'react-redux'
import { EntityState, EntityTypeEnum, ProductSectorMapping, WorkflowActions } from 'api'
import { SectorMappingDialogComponent } from './SectorMappingDialogComponent'
import { ClonedComponentByShowModal } from 'view/shared/modal'
import { UnhappyError, withUnhappyModalBoundary } from 'view/shared/error'
import React from 'react'
import { useProductSectorMappingReferenceData } from 'view/hooks/entities/productSectorMapping'
import { Locale, Translation } from 'locale'

interface SectorDialogProps extends ClonedComponentByShowModal {
  workflowId: string
  entityId: string
}

export const SectorMappingEditDialog: React.FC<SectorDialogProps> = withUnhappyModalBoundary(({ workflowId, onClose, entityId }) => {
  const dispatch = useDispatch()

  const productSectorMappingEntity = useProductSectorMappingReferenceData({ workflowId, entityId })
  const productSectorMapping = productSectorMappingEntity?.data.productSectorMapping

  if (!productSectorMappingEntity || !productSectorMapping) {
    throw new UnhappyError('Product mapping entity sector not found.')
  }

  const handleUpdate = (partialSectorMapping: Partial<ProductSectorMapping>) => {
    dispatch(
      WorkflowActions.createEntityUpdateReferenceData({
        entityId,
        entityType: EntityTypeEnum.PRODUCT_SECTOR_MAPPING_DRAFT,
        updatedEntity: {
          ...productSectorMappingEntity.data,
          productSectorMapping: {
            ...productSectorMappingEntity.data.productSectorMapping,
            ...partialSectorMapping
          }
        },
        workflowId
      })
    )
  }

  const handleSave = async () => {
    dispatch(WorkflowActions.createSubmitWorkflow(workflowId))
    if (onClose) {
      onClose()
    }
  }

  const handleClose = () => {
    dispatch(WorkflowActions.createCancelWorkflow(workflowId))
    if (onClose) {
      onClose()
    }
  }

  return (
    <SectorMappingDialogComponent
      title={
        productSectorMappingEntity?.entityState === EntityState.EXISTING
          ? Locale.translate(Translation.TC_SECTOR_EDIT_MAPPINGS)
          : Locale.translate(Translation.TC_SECTOR_CREATE_MAPPINGS)
      }
      productSectorMapping={productSectorMapping}
      id={productSectorMappingEntity?.id || ''}
      validationIssues={productSectorMappingEntity.validationIssues ?? []}
      onSave={handleSave}
      onUpdate={handleUpdate}
      onClose={handleClose}
    />
  )
})
